<template>
  <router-view></router-view>
</template>

<script>
import configAPI from '@/api/ConfigAPI'
import { SET_BACK_ROUTE } from '@/appLogic/route/store/actions'
import { SET_MVPDS } from '@/appLogic/targets/createTarget/store/actions'

export default {
  mounted: function () {
    // eslint-disable-next-line no-undef
    adobeAnalytics.viewHome()
    this.$store.dispatch(SET_BACK_ROUTE, 'user-audience-hub')
  },
  updated () {
    if (this.$store.state.auth.loggingOut) {
      this.$auth.signOut()
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// AudienceHub.vue?25560d1e